export default __webpack_public_path__ + "static/media/9a.a9311616.png";